import { Outlet, BrowserRouter, Routes, Route } from "react-router-dom";

import AppWithBottomBar from "components/base-app/AppWithBottomBar";
import CarsPage from "components/cars/CarsPage";
import CarPage from "components/cars/CarPage";
import LoginMagicCallback from "components/base-app/LoginMagicCallback";
import MapPage from "components/map/MapPage";
import MapEmbedPage from "components/map/MapEmbedPage";
import MapEmbedProtectedAreaForecoPage from "components/map/MapEmbedProtectedAreaForecoPage";
import MapEmbedCalculatorPage from "components/map/MapEmbedCalculatorPage";
import MapEmbedCalculatorFeedbackPage from "components/map/MapEmbedCalculatorFeedbackPage";
import ProfilePage from "components/profile/ProfilePage";
import ThankYouPage from "components/payment/ThankYouPage";
import PaymentFallbackPage from "components/payment/PaymentFallbackPage";
import LoginMagicLinkPage from "components/base-app/LoginMagicLinkPage";
import LoginEmailAndPasswordPage from "components/login/LoginEmailAndPasswordPage";
import AppAuthenticationPipe from "components/base-app/AppAuthenticationPipe";
import AppHomeLoaderPipe from "components/base-app/AppHomeLoaderPipe";
import TripsDashboard from "components/trips/TripsDashboard";
import PaymentTermsPage from "components/payment/PaymentTermsPage";
import RestarterRepairFormPage from "components/restarter/RestarterRepairFormPage";
import RestarterDashboardPage from "components/restarter/RestarterDashboardPage";
import ResetPassword from "components/login/ResetPassword";
import ForgetPasswordPage from "components/login/ForgetPaswordPage";
import CreateNewUserPage from "components/login/CreateNewUserPage";
import ESGConverterPage from "components/esg/ESGConverterPage";
import ESGConverterEmbedPage from "components/esg/ESGConverterEmbedPage";
import MyLittleFranceEmbedPage from "components/my-little-france/MyLittleFranceEmbedPage";

enum EMBED_ROUTE {
  // Rainforest Maps
  MAP_EMBED = "embed",
  MAP_EMBED_PROTECTED_AREA_FORECO = "embed/protected-area/foreco",
  // Rainforest Calculator Widgets
  MAP_CALCULATOR_EMBED = "embed/calculator",
  MAP_CALCULATOR_EMBED_FEEDBACK = "embed/calculator/feedback",
  // Restarter Widgets
  RESTARTER_REPAIR_FORM_EMBED = "embed/restarter/repair-form",
  RESTARTER_REPAIR_DASHBOARD = "embed/restarter/dashboard",
  // ESG Widgets
  ESG_CONVERTER_EMBED = "embed/esg-converter",
  // My Little France Widgets
  MY_LITTLE_FRANCE_EMBED = "embed/my-little-france",
}

enum BASE_ROUTE {
  MAGIC_LINK_CONFIRM = "login/magic-link-confirm",
  LOGIN_MAGIC_LINK = "login/magic-link",
  CAR_PAGE = "car/:id",
  CARS_PAGE = "cars",
  MAP = "map",
  PAYMENT_VIPPS_CALLBACK = "payment-vipps-callback",
  PAYMENT_VIPPS_FALLBACK = "payment-vipps-fallback/:orderId",
  PROFILE_PAGE = "profile",
  LOG_IN_EMAIL_AND_PASSWORD = "login/email-and-password",
  TRIPS_DASHBOARD = "trips",
  PAYMENT_TERMS = "terms-payment",
  RESET_PASSWORD = "reset-password",
  FORGET_PASSWORD = "forget-password",
  NEW_USER = "new-user",
  ESG_CONVERTER = "esg-converter",
}
export enum ROUTE {
  HOME = "/",
  // Home routes (MyUser)
  CAR_PAGE = "/h/car/:id",
  CARS_PAGE = "/h/cars",
  MAP = "/h/map",
  PROFILE_PAGE = "/h/profile",
  TRIPS_DASHBOARD = "/h/trips",
  ESG_CONVERTER = "/h/esg-converter",
  ESG_CONVERTER_EMBED = "/embed/esg-converter",
  MY_LITTLE_FRANCE_EMBED = "/embed/my-little-france",
  // Utility Routes
  MAGIC_LINK_CONFIRM = "/_/login/magic-link-confirm",
  LOGIN_MAGIC_LINK = "/_/login/magic-link",
  PAYMENT_VIPPS_CALLBACK = "/_/payment-vipps-callback",
  PAYMENT_VIPPS_FALLBACK = "/_/payment-vipps-fallback",
  LOG_IN_EMAIL_AND_PASSWORD = "/_/login/email-and-password",
  PAYMENT_TERMS = "_/terms-payment",
  RESET_PASSWORD = "_/reset-password",
  FORGET_PASSWORD = "_/forget-password",
  NEW_USER = "_/new-user",
}

const AppRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route path={ROUTE.HOME} element={<Outlet />}>
        <Route index element={<AppAuthenticationPipe />} />

        <Route path="h" element={<AppHomeLoaderPipe />}>
          <Route path={BASE_ROUTE.MAP} element={<MapPage />} />

          <Route path={BASE_ROUTE.CARS_PAGE} element={<CarsPage />} />
          <Route path={BASE_ROUTE.CAR_PAGE} element={<CarPage />} />
          <Route path={BASE_ROUTE.PROFILE_PAGE} element={<ProfilePage />} />
          <Route
            path={BASE_ROUTE.TRIPS_DASHBOARD}
            element={<TripsDashboard />}
          />
          <Route
            path={BASE_ROUTE.ESG_CONVERTER}
            element={<ESGConverterPage />}
          />
        </Route>

        <Route path={EMBED_ROUTE.MAP_EMBED} element={<MapEmbedPage />} />
        <Route
          path={EMBED_ROUTE.MAP_EMBED_PROTECTED_AREA_FORECO}
          element={<MapEmbedProtectedAreaForecoPage />}
        />

        <Route
          path={EMBED_ROUTE.MAP_CALCULATOR_EMBED}
          element={<MapEmbedCalculatorPage />}
        />
        <Route
          path={EMBED_ROUTE.MAP_CALCULATOR_EMBED_FEEDBACK}
          element={<MapEmbedCalculatorFeedbackPage />}
        />

        <Route
          path={EMBED_ROUTE.RESTARTER_REPAIR_DASHBOARD}
          element={<RestarterDashboardPage />}
        />
        <Route
          path={EMBED_ROUTE.RESTARTER_REPAIR_FORM_EMBED}
          element={<RestarterRepairFormPage />}
        />
        <Route
          path={EMBED_ROUTE.ESG_CONVERTER_EMBED}
          element={<ESGConverterEmbedPage />}
        />
        <Route
          path={EMBED_ROUTE.MY_LITTLE_FRANCE_EMBED}
          element={<MyLittleFranceEmbedPage />}
        />

        <Route path="_" element={<AppWithBottomBar />}>
          <Route path={BASE_ROUTE.NEW_USER} element={<CreateNewUserPage />} />
          <Route
            path={BASE_ROUTE.PAYMENT_TERMS}
            element={<PaymentTermsPage />}
          />
          <Route path={BASE_ROUTE.RESET_PASSWORD} element={<ResetPassword />} />
          <Route
            path={BASE_ROUTE.FORGET_PASSWORD}
            element={<ForgetPasswordPage />}
          />
          <Route
            path={BASE_ROUTE.PAYMENT_VIPPS_CALLBACK}
            element={<ThankYouPage />}
          />
          <Route
            path={BASE_ROUTE.PAYMENT_VIPPS_FALLBACK}
            element={<PaymentFallbackPage />}
          />
          <Route
            path={BASE_ROUTE.LOGIN_MAGIC_LINK}
            element={<LoginMagicLinkPage />}
          />
          <Route
            path={BASE_ROUTE.MAGIC_LINK_CONFIRM}
            element={<LoginMagicCallback />}
          />

          <Route
            path={BASE_ROUTE.LOG_IN_EMAIL_AND_PASSWORD}
            element={<LoginEmailAndPasswordPage />}
          />
        </Route>
      </Route>
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
